import { Icon } from '@/components/ui/icon';
import { useClientTranslation } from '@/lib/core/i18n';

/**
 * Inline "SOLD OUT" indicator shown next to the venue/location line on the
 * EDP when every occurrence is sold out (`isEveryOccurrenceSoldOut`). Literal color matches the fetched design's
 * `Foundation/Asia/7427c-500` token (`#971b2f`) — no semantic token maps to it.
 */
export function SoldOutBadge() {
  const t = useClientTranslation();

  return (
    <div className="flex h-3 items-center gap-1">
      <Icon name="user-xmark" width={12} height={12} className="text-[#971b2f]" />
      <span className="font-pp-neue-montreal text-[10px] font-semibold tracking-wide whitespace-nowrap text-[#971b2f] uppercase">
        {t('App.Events.SoldOut')}
      </span>
    </div>
  );
}
